import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

interface ErrorBadgeProps {
  count: number;
  onClick?: () => void;
  collapsed?: boolean;
  sx?: SxProps<Theme>;
}

const ErrorBadge: React.FC<ErrorBadgeProps> = ({
  count,
  onClick,
  collapsed,
  sx: customSx = {},
}) => {
  const stylesCollapsed: SxProps<Theme> = {
    position: 'absolute',
    left: '34px',
    bottom: '28px',
    width: '8px',
    height: '8px',
    backgroundColor: 'error.main',
    borderRadius: '12px',
    ...customSx,
  };

  return (
    <Box
      component="span"
      onClick={(event) => {
        if (onClick) {
          event.stopPropagation();
          onClick();
        }
      }}
      sx={
        collapsed
          ? stylesCollapsed
          : {
              backgroundColor: 'error.main',
              color: 'primary.contrastText',
              borderRadius: '12px', // Increased for a pill shape
              padding: collapsed ? '0px' : '0 6px', // Horizontal padding only
              fontSize: '12px',
              lineHeight: '18px', // Match this to the text line-height
              display: 'inline-flex',
              alignItems: 'center',
              height: collapsed ? '0px' : '18px', // Set a fixed height to match text
              minWidth: '18px', // Ensure circular shape for single-digit numbers
              justifyContent: 'center',
              ...customSx,
            }
      }
    >
      {collapsed ? '' : count}
    </Box>
  );
};

export default ErrorBadge;
